import { inject, Injectable } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { injectDispatch } from '@ngrx/signals/events';
import { authEvents, SessionAuthPayload } from '@kikkz/shared/auth/util';
import { AuthStore } from '../store/auth.store';

@Injectable()
export class AuthFacade {
  private readonly store = inject(AuthStore);
  private readonly dispatch = injectDispatch(authEvents);

  readonly idToken = this.store.idToken;
  readonly accessToken = this.store.accessToken;
  readonly refreshToken = this.store.refreshToken;
  readonly expiresAt = this.store.expiresAt;
  readonly isAuthenticated = this.store.isAuthenticated;
  readonly isLoading = this.store.isLoading;
  // Observable view for consumers that need to await auth resolution
  // (e.g. the HTTP interceptor holding back requests during startup).
  readonly isLoading$ = toObservable(this.store.isLoading);
  readonly isRefreshing = this.store.isRefreshing;
  readonly hasError = this.store.hasError;
  readonly userName = this.store.userName;
  readonly belongsToAdRestrictedGroup = this.store.belongsToAdRestrictedGroup;
  readonly accessDenied = this.store.accessDenied;
  readonly sessionUser = this.store.sessionUser;

  initAuth(): void {
    this.dispatch.initAuth();
  }

  logout(): void {
    this.dispatch.logout();
  }

  /** Materializes an authenticated session from a tenant-specific login flow (e.g. OAuth). */
  setSessionAuth(payload: SessionAuthPayload): void {
    this.dispatch.setSessionAuth(payload);
  }
}
